// src/store/slices/riskmizeSlice.js
import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  layerEnabled: false,
  drawerOpen: false,
  drawerMode: 'list',          // 'list' | 'detail'
  selectedIncidentId: null,
  incidents: [],               // GeoJSON FeatureCollection.features
  filters: { severity: [], category: [], timeRange: '7d' },
  settings: null,
  loading: false,
  error: null,
};

const slice = createSlice({
  name: 'riskmize',
  initialState,
  reducers: {
    toggleLayer(state) {
      state.layerEnabled = !state.layerEnabled;
      state.drawerOpen = state.layerEnabled;
      if (!state.layerEnabled) state.drawerMode = 'list';
    },
    closeDrawer(state) { state.drawerOpen = false; state.layerEnabled = false; },
    setIncidents(state, { payload }) { state.incidents = payload; },
    selectIncident(state, { payload }) {
      state.selectedIncidentId = payload;
      state.drawerMode = payload ? 'detail' : 'list';
      if (payload && !state.drawerOpen) state.drawerOpen = true;
    },
    returnToList(state) { state.drawerMode = 'list'; state.selectedIncidentId = null; },
    setFilters(state, { payload }) { state.filters = { ...state.filters, ...payload }; },
    setSettings(state, { payload }) { state.settings = payload; },
    setLoading(state, { payload }) { state.loading = payload; },
    setError(state, { payload }) { state.error = payload; },
  },
});

export const riskmizeActions = slice.actions;
export default slice.reducer;
